module.exports = __webpack_public_path__ + "static/media/bckg1red.3c7c55bd.png";